<template>
  <div id="checkout">
    <v-row>
      <v-col cols="12" sm="9">
        <v-stepper alt-labels v-model="step">
          <v-stepper-header>
            <div class="row-titles">
              <div>
                <div class="steps-layout">
                  <v-stepper-step
                    step="1"
                    :complete-icon="'local_shipping'"
                    class="font-icon-size"
                    :complete="step == 1 ? true : true"
                    :class="
                      step == 1 || step == 2 || step == 3
                        ? 'active-step'
                        : 'inactive-step'
                    "
                  >
                    <p class="label-text my-3">{{ $t("Shipping Details") }}</p>
                  </v-stepper-step>
                </div>
              </div>
              <div>
                <div class="steps-layout">
                  <v-stepper-step
                    step="2"
                    :complete-icon="'check'"
                    class="font-icon-size"
                    :complete="step == 2 ? true : true"
                    :class="
                      step == 2 || step == 3 ? 'active-step' : 'inactive-step'
                    "
                    :style="
                      step == 2
                        ? 'color: #ffc382 !important'
                        : 'color: gray !important'
                    "
                  >
                    <p class="label-text my-3">
                      {{ $t("OrderDetails") }}
                    </p>
                  </v-stepper-step>
                </div>
              </div>
              <div>
                <div class="steps-layout">
                  <v-stepper-step
                    step="3"
                    :complete-icon="'account_balance_wallet'"
                    class="font-icon-size"
                    :class="step == 3 ? 'active-step' : 'inactive-step'"
                    :complete="step == 3 ? true : true"
                  >
                    <p class="label-text my-3">
                      {{ $t("Payment Methods") }}
                    </p>
                  </v-stepper-step>
                </div>
              </div>
            </div>
            <v-row style="width:100%;">
              <v-stepper-step
                step="1"
                :complete-icon="'radio_button_checked'"
                :complete="step == 1 ? true : true"
                :class="
                  step == 1 || step == 2 || step == 3
                    ? 'active-step'
                    : 'inactive-step'
                "
              >
              </v-stepper-step>

              <v-divider
                step="2"
                :complete="step == 2 ? true : true"
                :class="
                  step == 2 || step == 3 ? 'line-active' : 'line-inactive'
                "
              ></v-divider>

              <v-stepper-step
                step="2"
                :complete-icon="'radio_button_checked'"
                :class="
                  step == 2 || step == 3 ? 'active-step' : 'inactive-step'
                "
                :complete="step == 3 ? true : true"
              >
              </v-stepper-step>

              <v-divider
                step="2"
                :complete="step == 3 ? true : true"
                :class="step == 3 ? 'line-active' : 'line-inactive'"
              ></v-divider>
              <v-stepper-step
                step="3"
                :complete-icon="'radio_button_checked'"
                :class="step == 3 ? 'active-step' : 'inactive-step'"
                :complete="step == 3 ? true : true"
              >
              </v-stepper-step>
            </v-row>
            <!--    <v-stepper-step
              step="1"
              class="shipping"
              :complete-icon="'local_shipping'"
              :complete="step == 1 ? true : true"
            >
              {{ $t("Shipping Details") }}
            </v-stepper-step> 

            <v-divider></v-divider>

            <v-stepper-step
              step="2"
              class="shipping"
              :complete-icon="'check'"
              :complete="step == 2 ? true : true"
            >
              {{ $t("OrderDetails") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              step="3"
              class="shipping"
              :complete-icon="'account_balance_wallet'"
              :complete="step == 3 ? true : true"
            >
              {{ $t("PaymentDetails") }}
            </v-stepper-step>
            -->
          </v-stepper-header>

          <div>
            <div v-if="step == 1" :step="1">
              <ShippingComponent
                :addresses="addresses"
                :countries="countries"
                :cities="cities"
                :defultAddressId="defultAddressId"
                :defultCityId="defultCityId"
                v-on:getAddresses="getCheckoutData"
                v-on:getCityId="handleCityChange"
              />
            </div>

            <div v-if="step == 2" :step="2">
              <NewOrderDetailsComponent
                :newCartItems="newCartItems"
                @cartChanged="fetchNewCart()"
                @updateCart="updateCartItems"
              />
            </div>

            <div v-if="step == 3" :step="3">
              <PaymentDetailsComponent
                :user_city_id="cityId"
                :address_id="address_id"
              />
            </div>
          </div>

          <div
            class="bafore-next-row"
            :style="
              step == 2
                ? 'padding: 1rem !important'
                : 'padding: 2rem !important'
            "
          >
            <v-btn class="btn-style " :disabled="step == 1" @click="prevStep()">
              {{ $t("Before") }}
            </v-btn>
            <v-btn class="btn-style" :disabled="step == 3" @click="nextStep()">
              {{ $t("Next") }}
            </v-btn>
          </div>
        </v-stepper>
      </v-col>
      <v-col cols="12" sm="3" class="sidebar-style">
        <div class="inputs-div">
          <p class="side-title">{{ $t("orderSummary") }}</p>
          <div>
            <b class="main-color">{{ $t("proNum") }}</b>
            <p class="side-data">{{ newTotalItems }}</p>
          </div>
          <div>
            <b class="main-color">{{ $t("subTotalPrice") }}</b>
            <p class="side-data">{{ newTotalPrices }} {{ $t("currency") }}</p>
          </div>
          <div v-if="step > 1">
            <b class="main-color">{{ $t("totalDeliveryFees") }}</b>
            <p class="side-data">
              {{ newTotlaShippment }} {{ $t("currency") }}
            </p>
          </div>
          <div v-if="step > 1 && newTotalVat > 0">
            <b class="main-color">{{ $t("vat") }}</b>
            <p class="side-data">{{ newTotalVat }} {{ $t("currency") }}</p>
          </div>
        </div>

        <div v-if="step > 1">
          <p class="orange-color totla-price-layout">
            {{ $t("totalFees") }}
            <span class="main-color">
              {{ newGrandTotal }} {{ $t("currency") }}</span
            >
          </p>
        </div>
      </v-col>
    </v-row>
    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import ShippingComponent from "@/components/Checkout/Shipping.vue";
import NewOrderDetailsComponent from "@/components/Checkout/NewOrderDetails.vue";
import PaymentDetailsComponent from "@/components/Checkout/PaymentDetails.vue";
export default {
  name: "NewCheckout",
  components: {
    ShippingComponent,
    NewOrderDetailsComponent,
    PaymentDetailsComponent
  },
  data() {
    return {
      step: 1,
      defaultProductImg: require("../../assets/images/favorite-item.png"),
      countries: [],
      addresses: [],
      cityId: "",
      cities: [],
      defultAddressId: 0,
      defultCityId: 0,
      selectedCountry: "",

      valid: false,
      addressValid: false,
      items: [],
      subTotal: "",
      totalQuantity: "",
      paymentData: {
        payment_method: "",
        card_number: "",
        card_holder_name: "",
        cvc: "",
        exp_month: "",
        exp_year: "",
        cartID:
          localStorage.cartID && localStorage.cartID != undefined
            ? localStorage.cartID
            : "",
        address_id: 0,
        user_address: {
          address: "",
          user_city_id: ""
        }
      },
      paymentId: "",
      jawabUrl: window.location.origin,
      paymentDialog: false,
      countDown: 3,
      years: [],
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ],
      newCartItems: [],
      newTotalItems: 0,
      newTotalPrices: 0,
      newTotalVat: 0,
      newTotlaShippment: 0,
      newGrandTotal: 0,
      address_id: ""
    };
  },
  methods: {
    updateCartItems() {
      this.updateCart();
    },

    updateCart() {
      this.$http
        .post(
          this.getApiUrl + "/market/cart/newupdate",
          {
            cartID:
              localStorage.cartID && localStorage.cartID != undefined
                ? localStorage.cartID
                : "",
            cartItems: this.newCartItems
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.fetchNewCart();
          } else {
            this.$refs.snack.sendErrorAlert(response.data.status.message);
          }
          //this.cartChanged = false;
        });
    },
    handleCityChange(cityId, addressId) {
      this.cityId = cityId;
      this.address_id = addressId;
      this.defultAddressId = addressId;
      this.fetchNewCart();
    },
    fetchNewCart() {
      this.$http
        .get(
          this.getApiUrl +
            "/market/newcart?user_city_id=" +
            this.cityId +
            "&cartID=" +
            (localStorage.cartID && localStorage.cartID != undefined
              ? localStorage.cartID
              : ""),
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.newCartItems = response.data.data.cart_items;
            this.newTotalItems = response.data.data.total_items;
            this.newTotalPrices = response.data.data.total_prices;
            this.newTotalVat = response.data.data.total_vat;
            this.newTotlaShippment = response.data.data.total_shipment;
            this.newGrandTotal = response.data.data.grandTotal_inlclude_vat;
          }
        });
    },

    generateYears() {
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i <= currentYear + 8; i++) {
        this.years.push(i.toString());
      }
    },
    getCheckoutData() {
      this.$http
        .get(
          this.getApiUrl +
            "/market/checkout?cartID=" +
            (localStorage.cartID && localStorage.cartID != undefined
              ? localStorage.cartID
              : ""),
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale
            }
          }
        )
        .then(response => {
          if (response.data.status.error == false) {
            this.addresses = response.data.data.addresses;
            this.defultAddressId = response.data.data.address_id;
            this.defultCityId = response.data.data.city_id;
            this.items = response.data.data.order.items;
            this.subTotal = response.data.data.order.subTotal;
            this.totalQuantity = response.data.data.order.totalQuantity;
            this.paymentData.address_id = response.data.data.address_id;

            if (this.items.length == 0) {
              this.$router.push({ path: "/" });
            }
            if (Object.keys(response.data.data.payment_data).length > 0) {
              this.paymentData.payment_method =
                response.data.data.payment_data.payment_method;

              this.paymentData.card_number =
                response.data.data.payment_data.card_number;

              this.paymentData.card_holder_name =
                response.data.data.payment_data.card_holder_name;

              this.paymentData.cvc = response.data.data.payment_data.cvc;

              this.paymentData.exp_month =
                response.data.data.payment_data.exp_month;

              this.paymentData.exp_year =
                response.data.data.payment_data.exp_year;
            }
          }
        });
    },

    getCountries() {
      this.$http
        .get(this.getApiUrl + "/market/countries", {
          headers: {
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.countries = response.data.data;
          }
        });
    },
    getCities() {
      this.$http
        .get(this.getApiUrl + "/market/cities/" + this.selectedCountry, {
          headers: {
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.cities = response.data.data;
          }
        });
    },

    nextStep() {
      if (this.step == 1) {
        if (!this.address_id) {
          //
          let msg = "Please Select Address";
          if (this.locale == "ar") {
            msg = "من فضلك أختر العنوان";
          }
          this.$refs.snack.sendErrorAlert(msg);
        } else {
          this.step = 2;
        }
      } else if (this.step == 2) {
        this.step = 3;
      }
    },
    prevStep() {
      if (this.step == 2) {
        this.step = 1;
      } else if (this.step == 3) {
        this.step = 2;
      }
    }
  },
  mounted() {
    this.generateYears();
    this.getCheckoutData();
    this.getCountries();
  }
};
</script>

<style lang="scss" scoped>
.bafore-next-row {
  display: flex;
  justify-content: space-between;
  padding: 2rem;
  margin-top: -20px;
  .btn-style {
    background-color: #10a8b1 !important;
    color: #fff;
    padding: 0px 35px;
    border-radius: 3px;
  }
}

.sidebar-style {
  background-color: #f5f5f6;
  padding: 2rem;
}
.side-data {
  background-color: white;
  padding: 9px;
  margin: 10px 0px;
  text-align: center;
}
p.side-title {
  font-size: 29px !important;
  border-bottom: 2px solid #dfdfdf;
  padding: 1rem 0px;
}
.totla-price-layout {
  display: flex;
  justify-content: space-between;
}
.shipping2 .v-stepper__step__step .v-icon {
  color: yellow !important;
}
.theme--light.v-stepper .v-stepper__step__step {
  color: red !important;
}

.v-application .primary {
  background-color: black !important;
}
.active-step {
  color: #ffc382 !important;
}
.line-active {
  border-color: #ffc382 !important ;
  background: #ffc382 !important;
}
.line-inactive {
  border-color: #c1c1c1 !important ;
  background: #c1c1c1 !important;
}

.row-titles {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: -30px;
  padding: 0px 1rem;
}
.inputs-div {
  border-bottom: 1px dashed #bababa;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
}
.orange-color {
  color: #ffc382 !important;
}
</style>
